






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {Promocao} from '@/model/resource/Promocao'
import {InputPromocaoSchema} from '@/schema/resource/Promocao/InputPromocaoSchema'

@Component
export default class PersistPromocaoView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputPromocaoSchema()
  promocao = new Promocao()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.promocao.getPromocao(id)
    }

    $.await.done('getPromocao')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.promocao.persistPromocao()
    await Helper.successAndPush('system.success.persist', '/promocao/list')
  }
}
